import React from 'react';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import { useQuery } from '@tanstack/react-query';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import pdfWorker from 'pdfjs-dist/build/pdf.worker?url';


GlobalWorkerOptions.workerSrc = pdfWorker;


export const usePDFDocument = (pdfFile?: File | string) => {
  const pdfUrl = React.useMemo(() => {
    if (typeof pdfFile === 'string') {
      return pdfFile;
    } else if (pdfFile instanceof File) {
      const blob = new Blob([ pdfFile ], { type: 'application/pdf' });

      return URL.createObjectURL(blob);
    }

    return;
  }, [ pdfFile ]);

  return useQuery({
    queryKey: [ 'pdf', pdfUrl ],
    queryFn: async () => {
      if (!pdfUrl) {
        return null;
      }

      const pdf = await getDocument(pdfUrl).promise;

      return pdf;
    }
  });
};
